<div class="d-flex flex-column h-100">
  <div class="actionBar">
    <input class="search w-100" type="text" placeholder="Search" [formControl]="filterText" />
    <div class="newDir h-100" ngbDropdown container="body" *ngIf="isMonitor == false">
      <button type="button" class="actionBtn" container="body" triggers="hover" ngbTooltip="Add New Credential" ngbDropdownToggle>
        <span class="bi bi-person-vcard" ></span>
        <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem *ngFor="let cloud of cloudProviders"
          (click)="addNewCredential(cloud.name, cloud.value)" style="color: var(--s-text-color)">
          {{ cloud.name }}
        </button>
      </div>
    </div>

  </div>

  <div class="right-side w-100">
    <div class="w-100">
      <div class="jobs">
        <table class="table table-hover table-condensed" cellspacing="0" id="sessionInfoList"
      style="border-collapse: collapse; white-space: nowrap">
      <thead>
        <tr class="jobHeadRow table-list-head" style="color: white; background-color: var(--s-primary-color);">
          <th resizable scope="col">
            <a style="text-decoration: none; cursor: default">#</a>
          </th>
          <th resizable scope="col">
            <a style="text-decoration: none; cursor: default">
              Name
            </a>
          </th>
          <th resizable scope="col">
            <a style="text-decoration: none; cursor: default">
              Infrastructure
            </a>
          </th>
          <th resizable scope="col" style="text-align:end;padding-right:35px" *ngIf="isMonitor == false">
            <a style="text-decoration: none; cursor: default;">
              Actions
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" style="cursor: pointer;" *ngFor="let cred of filteredCredentials; let i = index">
          <td style="cursor: pointer" scope="row">{{ i + 1}}</td>
          <td style="cursor: pointer" scope="row">{{ cred.friendlyName }}</td>
          <td style="cursor: pointer" scope="row">
            {{ cred.infrastructure }}
          </td>
          <td style="text-align:end" class="px-4" *ngIf="isMonitor == false">
            <button class="connect-button" (click)="updateInfraCred(cred.friendlyName)" triggers="hover" ngbTooltip="Update Credential">
              <span class="bi bi-pencil-square" style="color: var(--s-primary-color);"
               >
              </span>
            </button>
            <button class="connect-button" triggers="hover" ngbTooltip="Delete Credential">
              <span class="bi bi-trash text-danger"
                (click)="deleteInfra(cred.friendlyName)">
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
      </div>
    </div>
  </div>
</div>
